import { clsx, type ClassValue } from 'clsx';

/**
 * Utility function for conditionally constructing className strings.
 * Re-export from the UI package for convenience.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
